import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import u from "react";

function s() {
  var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _u$useState = u.useState(c),
      _u$useState2 = _slicedToArray(_u$useState, 2),
      e = _u$useState2[0],
      f = _u$useState2[1];

  var _u$useRef = u.useRef({
    current: e
  }),
      r = _u$useRef.current;

  return Object.defineProperty(r, "current", {
    get: function get() {
      return e;
    },
    set: function set(t) {
      Object.is(e, t) || (e = t, f(t));
    }
  }), r;
}

export { s as default, s as useStatefulRef };